/**
 * 项目信息相关的 API 路由
 */

import { Router } from 'express';
import { ProjectConfigManager } from '../../core/project-config.js';
import { ApiError, ApiErrorCode } from '../types.js';
import { logger } from '../../utils/logger.js';
import path from 'path';

const router = Router();

// 获取项目信息
router.get('/info', async (req, res, next) => {
  try {
    const workflowDir = path.join(process.cwd(), '.workflow');
    const projectConfig = new ProjectConfigManager(workflowDir);
    
    if (!await projectConfig.exists()) {
      throw new ApiError(
        ApiErrorCode.NOT_FOUND,
        'Project not initialized. Run "workflow init" first.',
        404
      );
    }
    
    const config = await projectConfig.get();
    res.success(config);
  } catch (error) {
    next(error);
  }
});

// 更新项目信息
router.put('/info', async (req, res, next) => {
  try {
    const { name, description } = req.body;
    
    if (!name && !description) {
      throw new ApiError(
        ApiErrorCode.VALIDATION_ERROR,
        'At least one field (name or description) is required',
        400
      );
    }
    
    const workflowDir = path.join(process.cwd(), '.workflow');
    const projectConfig = new ProjectConfigManager(workflowDir);
    
    if (!await projectConfig.exists()) {
      throw new ApiError(
        ApiErrorCode.NOT_FOUND,
        'Project not initialized. Run "workflow init" first.',
        404
      );
    }
    
    const updates: any = {};
    if (name) updates.name = name;
    if (description !== undefined) updates.description = description;
    
    const config = await projectConfig.update(updates);
    logger.info(`Project info updated: ${JSON.stringify(updates)}`);
    
    res.success(config);
  } catch (error) {
    next(error);
  }
});

// 获取项目设置
router.get('/settings', async (req, res, next) => {
  try {
    const workflowDir = path.join(process.cwd(), '.workflow');
    const projectConfig = new ProjectConfigManager(workflowDir);
    
    if (!await projectConfig.exists()) {
      throw new ApiError(
        ApiErrorCode.NOT_FOUND,
        'Project not initialized. Run "workflow init" first.',
        404
      );
    }
    
    const config = await projectConfig.get();
    res.success(config?.settings || {});
  } catch (error) {
    next(error);
  }
});

// 更新项目设置
router.put('/settings', async (req, res, next) => {
  try {
    const settings = req.body;
    
    if (!settings || typeof settings !== 'object') {
      throw new ApiError(
        ApiErrorCode.VALIDATION_ERROR,
        'Settings must be an object',
        400
      );
    }
    
    const workflowDir = path.join(process.cwd(), '.workflow');
    const projectConfig = new ProjectConfigManager(workflowDir);
    
    if (!await projectConfig.exists()) {
      throw new ApiError(
        ApiErrorCode.NOT_FOUND,
        'Project not initialized. Run "workflow init" first.',
        404
      );
    }
    
    const config = await projectConfig.updateSettings(settings);
    logger.info(`Project settings updated`);
    
    res.success(config);
  } catch (error) {
    next(error);
  }
});

export { router as projectRouter };